import { render, staticRenderFns } from "./WhatsappForm.vue?vue&type=template&id=48141f4b&"
import script from "./WhatsappForm.vue?vue&type=script&lang=js&"
export * from "./WhatsappForm.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports